import {BrowserRouter, Routes, Route} from 'react-router-dom'
import Nav from './components/nav/Nav'
// import Social from './components/social/Social'
import Home from './pages/home/Home'
import About from './pages/about/About' 
import Contact from './pages/contact/Contact' 
import Gallery from './pages/gallery/Gallery' 
import Plans from './pages/plans/Plans' 
import Trainers from './pages/trainers/Trainers' 
import NotFound from './pages/notFound/NotFound' 
import Footer from './components/Footer'
const App = () => {
  return (
    <div>
      <BrowserRouter basename='/gym'>
      <Nav />
      <Routes>
        <Route index element={<Home />} />
        <Route path='about' element={<About />} />
        <Route path='contact' element={<Contact />} />
        <Route path='gallery' element={<Gallery/>} />
        <Route path='plans' element={<Plans />} />
        <Route path='trainers' element={<Trainers />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
      <Footer />
      </BrowserRouter>
      
    </div>
  )
}

export default App
